import config from "../../../config";
import { Err, ReduxAction } from "../../../typings";
import { AppDispatch, AppGetState } from "../../../store";
import { globalContextRequest } from "../../globalContextRequest";

export const FETCH_CUSTOMERS_PENDING = "FETCH_CUSTOMERS_PENDING";
export const FETCH_CUSTOMERS_FULFILLED = "FETCH_CUSTOMERS_FULFILLED";
export const FETCH_CUSTOMERS_REJECTED = "FETCH_CUSTOMERS_REJECTED";

export type Customer = {
  id: string;
  name: string;
};

export function fetchCustomers() {
  return function(dispatch: AppDispatch): Promise<Customer[]> {
    return dispatch(fetchCustomersNoAcl());
  };
}

export function ensureCustomer(companyId: string) {
  return function(
    dispatch: AppDispatch,
    getState: AppGetState,
  ): Promise<Customer | null> {
    const state = getState().customers;
    const company = getCustomerById(state, companyId);
    if (company && company.id) {
      return Promise.resolve(company);
    } else {
      return dispatch(fetchCustomersNoAcl()).then(
        () => {
          return getCustomerById(getState().customers, companyId);
        },
        () => null,
      );
    }
  };
}

function fetchCustomersNoAcl() {
  return function(
    dispatch: AppDispatch,
    getState: AppGetState,
  ): Promise<Customer[]> {
    dispatch({ type: FETCH_CUSTOMERS_PENDING, payload: null });
    const route = getState().route;
    return dispatch(
      globalContextRequest({
        method: "GET",
        url: `${config.endpoints.csuApi}/customers`,
      }),
    ).then(
      ({ data }) => {
        dispatch({ type: FETCH_CUSTOMERS_FULFILLED, payload: data });
        return data;
      },
      (error: Err) => {
        dispatch({ type: FETCH_CUSTOMERS_REJECTED, payload: error });
        throw error;
      },
    );
  };
}

export type CustomersState = {
  pending: boolean;
  error: Err | null;
  entries: Customer[];
};

const defaultState: CustomersState = {
  pending: false,
  error: null,
  entries: [],
};

export default function(
  state: CustomersState = defaultState,
  action: ReduxAction<any>,
): CustomersState {
  switch (action.type) {
    case FETCH_CUSTOMERS_PENDING:
      return {
        ...state,
        pending: true,
      };
    case FETCH_CUSTOMERS_REJECTED:
      return {
        entries: [],
        error: action.payload,
        pending: false,
      };
    case FETCH_CUSTOMERS_FULFILLED:
      return {
        entries: action.payload,
        error: null,
        pending: false,
      };
    default:
      return state;
  }
}

export function getCustomerById(
  state: CustomersState,
  customerId: string,
): Customer | null {
  return (
    getCustomersList(state).find(customer => customer.id === customerId) || null
  );
}

export function getCustomersPending(state: CustomersState): boolean {
  return state.pending;
}

export function getCustomersError(state: CustomersState): Err | null {
  return state.error;
}

export function getCustomersList(state: CustomersState): Customer[] {
  return state.entries;
}
